<template>
    <div>
		<div class="loading" v-if="analysis.question.length == 0">
			<Loading text="Loading responses..." background="#f2e2f4" color="#913b9c"></Loading>
		</div>

		<div class="questionnaire analysis" v-else>
			<div v-for="(question, index) in analysis.question"
				class="question card"
				:key="question.id">
                <h5>{{ index + 1 }}</h5>
                <QuestionViewer :question="question"></QuestionViewer>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import OutcomeMixin from '../mixin'

import Loading from '@/module/component/Loading'

import QuestionViewer from './Question'


const HORIZONTAL_ANALYSIS_TYPE = ['slider', 'scroller', 'radio', 'star', 'binary']

export default {
    name: 'questionnaire-viewer',
    mixins: [ OutcomeMixin ],

    methods: {
        analysisComponent(question) {
            if (HORIZONTAL_ANALYSIS_TYPE.includes(question.type))
                return 'HorizontalAnalysis'
            return 'VerticalAnalysis'
        }
    },

    components: {
        Loading,
        QuestionViewer
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";
@import "@/module/patient/card/component/table/style/analysis.scss";

* {
    scroll-behavior: smooth;
}
.loading {
    padding: 50px 0;
    background: #f2e2f4;
}
.analysis .question.card {
    margin-bottom: 15px;
    padding-top: 0px;
    padding-left: 0;
    padding-right: 0;
    h5 {
        line-height: 36px;
    }
    h5::before {
        top: 40px;
    }
}

.text b {
	color: #3f3f3f;
}
.answer {

}
.answer-option {
	padding: 10px 5px 0 10px;
}
.answer .bar {
	margin-top: 10px;
	height: 36px;
	padding: 8px 15px;
	font-size: 16px;
	font-weight: 700;
	white-space: nowrap;

	span {
		float: right;
		font-weight: 400;
		opacity: 0.6;
	}
}
.answer .option {
	border: 1px solid $questionnaire-color;
	background-color: #fcf1ff;
	padding: 5px;
	margin-bottom: 5px;
	font-size: 14px;
	line-height: 24px;
	font-weight: 600;
	color: #833e93;
}
.horizontal-progress-wrapper {
	width: 100%;
	height: 22px;
	position: relative;
	background: #eeeeee;
	margin: 2px 0px;
	cursor: pointer;
}
.horizontal-progress {
	position: absolute;
	background: $questionnaire-color;
	top: 0; bottom: 0;
	left: 0;
}
</style>
